import styles from './ExperimentTitle.module.css';
import { useEffect, useState } from 'react';
import { experimentsService } from '../../../Services/Experiments.services';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import { shortId } from '../../../Utils/Utils';

function ExperimentTitle({ experimentId }) {
    const [experiment, setExperiment] = useState(null);

    const fetchExperimentName = async () => {
        const experiment = await experimentsService.getExperiment(experimentId);
        setExperiment(experiment);
    };

    useEffect(() => {
        void fetchExperimentName();
    }, [experimentId]);

    return !experiment
        ? (<span className={styles.loading}>Loading...</span>)
        : (
            <Tooltip
                className={styles.title}
                title={`Experiment ID: ${experimentId}`}
            >
                {experiment?.name ?? shortId(experimentId)}
            </Tooltip>
        );
}

ExperimentTitle.propTypes = {
    title: PropTypes.string,
    experimentId: PropTypes.string,
    status: PropTypes.string,
};

export default ExperimentTitle;
